module.exports = {
	"classes": [
		"ambassador-program",
		"header-dark",
		"theme-dark"
	],
	"title": "Ambassador Program",
	"metas": {
		"description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?"
	},
	"opengraph": {
		"og:title": "Ambassador Program",
		"og:description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?",
		"og:url": "https://auth0.com/ambassador-program",
		"og:image": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-7679141259.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-7679141259.png"
	},
	"twittercard": {
		"twitter:title": "Ambassador Program",
		"twitter:description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-7679141259.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ambassador-program/metadata.json
// module id = 1357
// module chunks = 0